import { useState } from "react";
import "./App.css";
import { dict } from "./i18n";
import useLenis from "./hooks/useLenis";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import Manifesto from "./components/Manifesto";
import Portfolio from "./components/Portfolio";
import EditorialMarquee from "./components/EditorialMarquee";
import Process from "./components/Process";
import Pricing from "./components/Pricing";
import CustomWeb from "./components/CustomWeb";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import CtaSection from "./components/CtaSection";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

const WA_NUMBER = "6281381189339";

function App() {
  useLenis();
  const [lang, setLang] = useState("id");
  const t = dict[lang];

  const waMessage =
    lang === "id"
      ? "Halo NextStore.id, saya tertarik dengan jasa pembuatan Shopify. Bisa diskusi lebih lanjut?"
      : "Hello NextStore.id, I'm interested in your Shopify service. Can we chat?";
  const waLink = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(waMessage)}`;

  return (
    <div className="App grain min-h-screen bg-[var(--bg)] text-[var(--text)] font-body overflow-x-clip">
      <Navbar t={t} lang={lang} setLang={setLang} waLink={waLink} />
      <main>
        <Hero t={t} waLink={waLink} />
        <TrustBar t={t} />
        <Manifesto t={t} />
        <Portfolio t={t} />
        <EditorialMarquee />
        <Process t={t} />
        <Pricing t={t} waLink={waLink} />
        <CustomWeb t={t} waLink={waLink} />
        <Testimonials t={t} />
        <Faq t={t} />
        <CtaSection t={t} waLink={waLink} />
      </main>
      <Footer t={t} waLink={waLink} />
      <FloatingWhatsApp waLink={waLink} />
    </div>
  );
}

export default App;
